module.exports = __webpack_public_path__ + "img/iphone7.85d62c35.png";